import React from 'react'

function SvgLogout() {
  return (
    <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.79412 13.9995V15.7495C7.79412 16.2136 7.98004 16.6588 8.31099 16.9869C8.64193 17.3151 9.09079 17.4995 9.55882 17.4995L15.7353 17.4995C16.2033 17.4995 16.6522 17.3151 16.9831 16.9869C17.3141 16.6588 17.5 16.2136 17.5 15.7495L17.5 5.24951C17.5 4.78538 17.3141 4.34026 16.9831 4.01208C16.6522 3.68389 16.2033 3.49951 15.7353 3.49951L9.55882 3.49951C9.09079 3.49951 8.64194 3.68389 8.31099 4.01208C7.98004 4.34026 7.79412 4.78538 7.79412 5.24951V6.99951M13.0882 10.4995L2.5 10.4995M2.5 10.4995L5.14706 13.1245M2.5 10.4995L5.14706 7.87451"
      stroke="#202020"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
  )
}

export default SvgLogout